import { useQuery } from '@tanstack/react-query';
import { wmsAPI } from '../utils/api';
import { WmsStockInfo } from '../types';

export function useWmsStock(prodottoId: string | undefined) {
  return useQuery<WmsStockInfo>({
    queryKey: ['wms-stock', prodottoId],
    queryFn: async () => {
      const response = await wmsAPI.getStock(prodottoId!);
      return response.data;
    },
    enabled: !!prodottoId,
    staleTime: 60_000,
  });
}

export function useWmsStockBatch(prodottoIds: string[]) {
  return useQuery<Map<string, WmsStockInfo>>({
    queryKey: ['wms-stock-batch', prodottoIds],
    queryFn: async () => {
      const response = await wmsAPI.getStockBatch(prodottoIds);
      const items: WmsStockInfo[] = response.data.items || [];
      const map = new Map<string, WmsStockInfo>();
      for (const item of items) {
        map.set(item.prodotto_id, item);
      }
      return map;
    },
    enabled: prodottoIds.length > 0,
    staleTime: 60_000,
  });
}
